<template lang="html">
  <div>
    <img
      :src="src"
      :style="style"
    />
  </div>
</template>

<script>
  export default {
    data () {
      return {
        src: ''
      }
    },
    computed: {
      style () {
        return `display:block;width:100%;border-radius:${this.radius}px`
      }
    },
    props: {
      source: {
        type: String,
        default: 'cdn'
      }, // 可选值: 'local'
      imgId: Number,
      radius: {
        type: Number,
        default: 0
      }
    },
    mounted () {
      let that = this
      if (that.imgId != 0) {
        that.$api.image.detail(that.imgId).then(res => {
          let src
          switch (that.source) {
            case 'local': src = res.data.upload
            break;
            case 'cdn': src = res.data.private_cdns[0].cdn_url
            break;
            default: src = res.data.upload
          }
          that.src = src
        })
      }
    }
  }
</script>

<style lang="css" scoped>
</style>
